import { render, staticRenderFns } from "./hqcontact-add-or-update.vue?vue&type=template&id=6f425aa9&scoped=true&"
import script from "./hqcontact-add-or-update.vue?vue&type=script&lang=js&"
export * from "./hqcontact-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./hqcontact-add-or-update.vue?vue&type=style&index=0&id=6f425aa9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f425aa9",
  null
  
)

export default component.exports